import { render, staticRenderFns } from "./tenantcompany.vue?vue&type=template&id=0a42414b&"
import script from "./tenantcompany.vue?vue&type=script&lang=js&"
export * from "./tenantcompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports